module.exports = __webpack_public_path__ + "static/media/emptyCart.78c39c75.png";